import { useRouter, useSearchParams } from "next/navigation";
import React from "react";

import QuestionLayout from "@/app/layout/question";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import QuestionsSupportSection from "@/components/organisms/question-section/questions-support-section";
import { DestinationEdit, RenewalPage } from "@/config/app-constant";
import { APPLICATION } from "@/constants";
import { LocationToContent } from "@/utils/schema/location-to-page-schema.utils";

import FCDOCountryAndDuplicateCountryModal from "./fcod-country-and-duplicate-country-modal";
import LocationToFormSection from "./location-to-form-section";
import { useLocationTo } from "../provider/location-to-provider";

function LocationToSection({
  overlayArea,
}: Readonly<{
  overlayArea: LocationToContent;
  application?: string;
}>) {
  const {
    buttonDisable,
    buttonLoading,
    handleSubmitButton,
    handleBackButton,
    isOpenUnsavedChangesModal,
    setIsOpenUnsavedChangesModal,
    scrollRefArray,
    isFCDOModalOpen,
    setIsFCDOModalOpen,
    selectedFCDOCountryCode,
  } = useLocationTo();
  const searchParams = useSearchParams();
  const editPage = searchParams.get(DestinationEdit);
  const router = useRouter();

  const prevOnClickHandler = () => {
    handleBackButton();
  };

  const nextOnClickHandler = () => {
    handleSubmitButton();
  };

  const handleBackToRenewalContinue = () => {
    setIsOpenUnsavedChangesModal(false);
    router.push("/");
  };

  const { current } = useWizard();
  return (
    <>
      <FCDOCountryAndDuplicateCountryModal
        fcdoCountry={isFCDOModalOpen}
        setFcdoCountry={setIsFCDOModalOpen}
        isModalOpen={isFCDOModalOpen}
        setIsModalOpen={setIsFCDOModalOpen}
        fcdoCountrySubTextText={overlayArea?.fcdoCountrySubTextText}
        sameCountrySubTextText={overlayArea?.sameCountrySubTextText}
        fcdoCountryBtnText={overlayArea?.fcdoCountryBtnText}
        sameCountryBtnText={overlayArea?.sameCountryBtnText}
        fcdoCountryHeaderText={overlayArea?.fcdoCountryHeaderText}
        sameCountryHeaderText={overlayArea?.sameCountryHeaderText}
        customFcdoMessages={overlayArea?.customFcdoMessage}
        selectedCountryCode={selectedFCDOCountryCode}
      />
      <QuestionLayout
        formSection={<LocationToFormSection pageContent={overlayArea} />}
        descriptionContent={
          <QuestionsSupportSection
            pageContent={{ ...overlayArea, page: "travelling-to" }}
          />
        }
        footer={{
          isHideFooterBack:
            (APPLICATION === RenewalPage && editPage !== "true") ||
            (APPLICATION !== RenewalPage && editPage === "true"),
          isLoading: buttonLoading,
          isDisabledBack: false,
          isDisabledContinue: buttonDisable,
          footerActionBack: prevOnClickHandler,
          footerActionContinue: nextOnClickHandler,
          id: "travelling-to",
          brand: "staysure",
          ctaButtonText: editPage
            ? overlayArea.finishEditingBtnText
            : overlayArea.ctaButtonText,
        }}
        progressBarPercent={current.progressBarPercentage ?? 15}
        backToRenewalSection={{
          isOpenUnsavedChangesModal,
          setIsOpenUnsavedChangesModal,
          onContinueClick: handleBackToRenewalContinue,
          backToRenewalText: overlayArea.backToRenewalsText ?? "",
        }}
        scrollRefs={scrollRefArray}
      />
    </>
  );
}
export default LocationToSection;
